<p-toast></p-toast>
<div class="card" style="position: relative">
    <span class="page-title"
        ><i class="pi pi-file-export mr-2"></i>Face Value Usage</span
    >
    <!-- <p-dialog
        [modal]="true"
        [closable]="false"
        [style]="{ width: screenWidth < 900 ? '65vw' : '35vw' }"
    >
        <app-loading [message]="loadingMessage()"></app-loading>
    </p-dialog> -->
    <div class="table-container mt-6">
        <p-table responsiveLayout="scroll" [value]="stockAllocations()" stripedRows>
            <ng-template pTemplate="header">
                <tr>
                    <th>Allocation ID</th>
                    <th>Status</th>
                    <th>Start Serial No.</th>
                    <th>End Serial No.</th>
                    <th>Allocated Stock</th>
                    <th>Stock Left</th>
                    <th>Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-batch>
                <tr>
                    <td style="width: 14%; min-width: 7rem">{{ batch.id }}</td>
                    <td style="width: 14%; min-width: 7rem">
                        {{ batch.active ? "Active" : "Inactive" }}
                    </td>
                    <td style="width: 14%; min-width: 7rem">
                        {{ batch.startSerialNumber }}
                    </td>
                    <td style="width: 14%; min-width: 7rem">
                        {{ batch.endSerialNumber }}
                    </td>
                    <td style="width: 14%; min-width: 7rem">
                        {{ batch.requestedQuantity }}
                    </td>
                    <td style="width: 14%; min-width: 7rem">
                        {{ batch.stockLeft }}
                    </td>
                    <td style="width: 14%; min-width: 7rem">
                        <p-button
                            icon="pi pi-file-export"
                            size="small"
                            label="New Record"
                            [disabled]="!batch.active"
                            (click)="newUsageClicked(batch.id)"
                            outlined="true"
                            class="my-2"
                        ></p-button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
